// Radiologist entry point — role-aware routing:
// • DycoVue radiologist (radiologistType: 'dycovue') → /radiologist/reader-portal
// • Facility radiologist (radiologistType: 'facility') → PACS Scan Board (all facility studies)
// • clinician / super_clinician / admin → PACS Scan Board
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import OldPacsDashboard from './OldPacsDashboard';

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const isDycovueRadiologist = user?.role === 'radiologist' && user?.radiologistType !== 'facility';

  useEffect(() => {
    if (isDycovueRadiologist) {
      navigate('/radiologist/reader-portal', { replace: true });
    }
  }, [navigate, isDycovueRadiologist]);

  if (!user || isDycovueRadiologist) return null;
  return <OldPacsDashboard />;
};

export default Dashboard;
